import React from "react";
import "./CSS/MobileBottomBar.css";
import MessageIcon from "../Assets/message.svg";
import TaskIcon from "../Assets/task-square.svg";
import ListIcon from "../Assets/List-two.svg";
import HomeIcon from "../Assets/home.svg";
import { lightHaptic } from "../native/capacitor";

const MobileBottomBar = ({ selectedPage, setSelectedPage }) => {
  const handleTabChange = async (nextPage) => {
    if (selectedPage === nextPage) return;
    await lightHaptic();
    setSelectedPage(nextPage);
  };

  return (
    <div className="mobile-bottom-bar">
            <button
        onClick={() => handleTabChange("home")}
        className={selectedPage === "home" ? "active" : "home-inactive"}
      >
        <img src={HomeIcon} alt="Home" className="home-img"/>
        <span>Home</span>
      </button>
      <button
        onClick={() => handleTabChange("chat")}
        className={selectedPage === "chat" ? "active" : ""}
      >
        <img src={MessageIcon} alt="chat" />
        <span>Chat</span>
      </button>

      <button
        onClick={() => handleTabChange("review")}
        className={selectedPage === "review" ? "active" : ""}
      >
        <img src={TaskIcon} alt="video" />
        <span>Video</span>
      </button>

      <button
        onClick={() => handleTabChange("diagram")}
        className={selectedPage === "diagram" ? "active" : ""}
      >
        <img src={ListIcon} alt="About" />
        <span>About</span>
      </button>
    </div>
  );
};

export default MobileBottomBar;
